<template>
  <div class="offsite-detail">
    <!-- 合同信息 -->
    <div class="contract-info">
      <div class="contract-header">
        <div>
          <span class="label">会销活动ID：</span>
          <span class="value">{{ detail.canSellId }}</span>
          <template v-if="detail.personName === userInfoBase.user_name">
            <van-icon
              name="description"
              class="icon"
              @click="handleCopy()"
            />
          </template>
        </div>
        <div class="flex">
          <div>
            <span class="label">会销类型：</span>
            <span class="value">{{ detail.canSellType }}</span>
          </div>
          <div>
            <el-button
              @click="qrcodePopup = true"
              round
              size="mini"
              type="primary"
            >
              专属激活二维码
            </el-button>
          </div>
        </div>
      </div>

      <!-- 基础信息网格 -->
      <div class="info-grid">
        <div class="grid-row">
          <div class="grid-item">
            <span class="label">日期:</span>
            <span class="value">{{ date }}</span>
          </div>
          <div class="grid-item">
            <span class="label">销售:</span>
            <span class="value">{{ detail.personName }}</span>
          </div>
          <div class="grid-item">
            <span class="label">区域:</span>
            <span class="value">{{ detail.region }}</span>
          </div>
        </div>

        <div class="grid-row">
          <div class="grid-item">
            <span class="label">渠道:</span>
            <span class="value">{{ detail.channel }}</span>
          </div>
          <div class="grid-item">
            <span class="label">二级机构:</span>
            <span class="value">{{ detail.secondLevelRegion }}</span>
          </div>
          <div class="grid-item">
            <span class="label">三级机构:</span>
            <span class="value">{{ detail.threeLevelRegion }}</span>
          </div>
        </div>

        <div class="grid-row">
          <div class="grid-item">
            <span class="label">预计到场人数:</span>
            <span class="value">{{ detail.customerSize }}</span>
          </div>
          <div class="grid-item">
            <span class="label">开卡数:</span>
            <span class="value">{{ detail.kaiSize	 }}</span>
          </div>
          <div class="grid-item">
            <span class="label">退卡数:</span>
            <span class="value">{{ detail.deleteCardNumbers }}</span>
          </div>
        </div>

        <div class="grid-row">
          <div class="grid-item">
            <span class="label">剩余开卡数:</span>
            <span class="value">{{ detail.remainingSize }}</span>
          </div>
          <div class="grid-item">
            <span class="label">激活人数:</span>
            <span class="value">{{ detail.activeSize }}</span>
          </div>
          <div class="grid-item">
            <span class="label">送检人数:</span>
            <span class="value">{{ detail.checkSize }}</span>
          </div>
        </div>

        <div class="grid-row">
          <div class="grid-item">
            <span class="label">已出报告人数:</span>
            <span class="value">{{ detail.reportSize }}</span>
          </div>
          <div class="grid-item">
            <span class="label">实际应收金额:</span>
            <span class="value">{{ detail.actualAmt }}</span>
          </div>
          <div class="grid-item">
            <span class="label">升单人数:</span>
            <span class="value">{{ detail.shengdanCount }}</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="grid-item">
            <span class="label">回款金额:</span>
            <span class="value">{{ detail.returnedAmount }}</span>
          </div>
          <div class="grid-item">
            <span class="label">财务是否核对:</span>
            <span class="value">{{ detail.returnedCheckStatus }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 回款录入 -->
    <div class="contract-info">
      <div class="btn">
        <el-button
          :disabled="detail.personName !== userInfoBase.user_name"
          @click="upload"
          round
          size="mini"
          type="primary"
        >
          回款录入
        </el-button>
      </div>
      <van-collapse
        v-model="activeName"
        v-if="detail.canSellCollectionInputs && detail.canSellCollectionInputs.length > 0"
      >
        <van-collapse-item
          title="回款明细数据"
          name="1"
        >
          <div
            class="info-grid info-grid2"
            v-for="item in detail.canSellCollectionInputs"
            :key="item.id"
          >
            <div class="grid-row">
              <div class="grid-item">
                <span class="label">录入时间:</span>
                <span class="value">{{ item.createTime }}</span>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-item">
                <span class="label">录入人:</span>
                <span class="value">{{ item.personName }}</span>
              </div>
              <div class="grid-item">
                <span class="label">支付方式:</span>
                <span class="value">{{ item.payType }}</span>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-item">
                <span class="label">回款金额:</span>
                <span class="value">{{ item.amountPrice }}</span>
              </div>
              <div class="grid-item">
                <span class="label">财务是否核对:</span>
                <span class="value">{{ item.checkStatus	 }}</span>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-item">
                <span class="label">交易单号:</span>
                <span class="value">{{ item.transactionNumber }}</span>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <!-- 未明细数据提示 -->
    <div class="undetailed-data">
      <van-icon
        name="records"
        class="icon"
      />
      <span>卡明细数据</span>
    </div>

    <!-- 卡明细数据表格 -->
    <div
      v-if="detail.canSellReservationDetailsList && detail.canSellReservationDetailsList.length > 0"
      class="card-details-table"
    >
      <el-table
        :data="detail.canSellReservationDetailsList"
        style="width: 100%"
        size="small"
        :header-cell-style="{
          background: '#f7f8fa',
          color: '#969799',
          fontWeight: 'normal'
        }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="40"
          align="center"
        />
        <el-table-column
          prop="cardNo"
          label="卡号"
          min-width="120"
        >
          <template #default="{ row }">
            <div
              class="card-no-cell"
              :class="{'del': row.rowStatus === '0'}"
            >
              <span>{{ row.cardNo }}</span>
              <template v-if="detail.personName === userInfoBase.user_name && row.rowStatus !== '0'">
                <van-icon
                  name="description"
                  class="copy-icon"
                  @click="handleCopy(row)"
                />
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="personName"
          label="激活人姓名"
          min-width="60"
          align="center"
        >
          <template #default="{ row }">
            {{ row.personName ? desensitizeName(row.personName) : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="userStatus"
          label="是否已采样"
          width="40"
          align="center"
        >
          <template #default="{ row }">
            {{ row.userStatus === "1" ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="reportStatus"
          label="是否已生成报告"
          width="50"
          align="center"
        >
          <template #default="{ row }">
            {{ row.reportStatus === "1" ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="detail.canSellType === '本地会销'"
          prop="isShengdan"
          label="是否升单"
          width="45"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <!-- 待开卡状态 -->
    <div
      v-if="!detail.canSellReservationDetailsList || detail.canSellReservationDetailsList.length === 0"
      class="waiting-status"
    >
      <van-icon
        name="clock-o"
        class="icon"
      />
      <span>待开卡</span>
    </div>
    <van-popup
      v-if="showUploadPopup"
      v-model="showUploadPopup"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showUploadPopup = false">
            取消
          </div>
          <div
            class="booking-submit"
            @click="uploadConfirm"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <div class="booking-list-cancel">
          <van-form>
            <van-field
              name="checkboxGroup"
              label="支付方式"
            >
              <template #input>
                <van-radio-group
                  v-model="uploadForm.payType"
                  direction="horizontal"
                >
                  <van-radio name="1">非对公转账</van-radio>
                  <van-radio name="2">对公转账</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="uploadForm.remark"
              rows="3"
              autosize
              label="备注"
              type="textarea"
              placeholder="请输入备注"
            />
            <div class="booking-paymentReceipt">
              <paymentReceipt
                ref="paymentReceipt"
                @answerChange="answerChange"
                :payMethod="uploadForm.payType == 1 ? 'weixin' : 'duigong'"
              />

            </div>

          </van-form>
        </div>
      </div>
    </van-popup>
    <!-- 二维码 -->
    <van-popup
      v-model="qrcodePopup"
      round
      closeable
      position="center"
    >
      <div class="qrcode">
        <p>请截图保存</p>
        <img :src="detail.qrlink" />
      </div>
    </van-popup>
    <!-- 页面loading -->
    <van-overlay
      :show="pageLoading"
      z-index="9999"
    >
      <div class="page-loading">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from "vant";
import getUserInfo from "@/models/userInfo";
import offsiteService from "@/apis/offsite/index.js";
import * as dd from "dingtalk-jsapi";
import paymentReceipt from "@/views/form/components/paymentReceipt";
export default {
  name: "OffsiteDetail",
  components: {
    paymentReceipt,
  },
  data() {
    return {
      date: "",
      detail: {},
      currentUserInfo: {},
      userInfoBase: {},
      activeName: [],
      showUploadPopup: false,
      uploadForm: {
        payType: undefined,
        remark: undefined,
      },
      pageLoading: false,
      qrcodePopup: false,
    };
  },
  async mounted() {
    dd.biz.navigation.setTitle({
      title: "会销详情", //控制标题文本，空字符串表示显示默认文本
    });
    this.date = this.$route.query.date;
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getUser();
    this.getDetail();
  },
  methods: {
    answerChange(fileList) {
      this.fileList = fileList.answer;
    },
    upload() {
      this.uploadForm = {};
      this.fileList = [];
      this.showUploadPopup = true;
    },
    uploadConfirm() {
      if (this.uploadIng) return;
      const { uploadForm, fileList } = this;
      let errMsg = "";
      if (!uploadForm.payType) {
        errMsg = "请选择支付方式";
      } else if (!this.fileList.length) {
        errMsg = "请上传付款凭证";
      } else if (fileList.some((item) => item.status === "uploading")) {
        errMsg = "文件正在上传中，请稍后";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }
      if (fileList.some((item) => item.message)) {
        this.dupPrompt = true;
        return;
      }
      this.uploadIng = true;
      offsiteService
        .collectionInputApi({
          ...uploadForm,
          uploadFiles: fileList,
          personCode: this.currentUserInfo.ding_user_id,
          personName: this.currentUserInfo.user_name,
          canSellId: this.detail.canSellId,
          channel: this.detail.channel,
          firstLevelRegion: this.detail.secondLevelRegion,
          secondLevelRegion: this.detail.threeLevelRegion,
          canSellType: this.detail.canSellType,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.uploadIng = false;
            Toast(res.message);
          } else {
            Toast("上传成功");
            this.getDetail();
            this.showUploadPopup = false;
            this.uploadIng = false;
          }
        })
        .catch(() => {
          this.uploadIng = false;
        });
    },
    getUser() {
      offsiteService.getUserApi(this.currentUserInfo.user_id).then((res) => {
        this.userInfoBase = res.data.sellUserInfo;
      });
    },
    getDetail() {
      this.pageLoading = true;
      offsiteService
        .detailCanSellApi({
          canSellId: this.$route.query.id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.detail = res.data;
            this.$forceUpdate();
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    formatMoney(amount) {
      return amount.toLocaleString();
    },
    // 复制成功回调
    onCopySuccess() {
      Toast("复制成功");
    },
    // 复制失败回调
    onCopyError() {
      Toast("复制失败，请手动复制!");
    },
    desensitizeName(name) {
      // 如果姓名长度为1，直接返回姓名
      if (name.length === 1) {
        return name;
      }
      // 提取姓氏
      const surname = name[0];
      // 计算名字部分的长度
      const nameLength = name.length - 1;
      // 生成星号字符串
      const asterisks = "*".repeat(nameLength);
      // 拼接脱敏后的姓名
      return surname + asterisks;
    },
    handleCopy(row) {
      const content = row
        ? `卡号：${row.cardNo}\n密码：${row.cardPassword}`
        : this.detail.canSellId;
      // navigator.clipboard.writeText(content);
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        Toast("复制成功");
        return navigator.clipboard.writeText(content);
      } else {
        // 创建text area
        const textArea = document.createElement("textarea");
        textArea.value = content;
        // 使text area不在viewport，同时设置不可见
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        Toast("复制成功");
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    selectChange(value) {
      const { cuotomerList } = this;
      cuotomerList.some((item) => {
        if (item.empi === value) {
          // 检查用户渠道信息
          if (!item.scrm_account_id) {
            this.$dialog
              .confirm({
                title: "提示",
                message: "该用户的渠道为空，需要先完善渠道信息",
                confirmButtonText: "去编辑",
                cancelButtonText: "取消",
              })
              .then(() => {
                // 确认，跳转到编辑页面
                this.$router.push({
                  name: "BookingAdd",
                  query: {
                    type: "edit",
                    id: item.empi,
                  },
                });
              })
              .catch(() => {
                // 取消，清空选择
                this.cuotomer = undefined;
                this.currentCuotomer = undefined;
              });
            return true;
          }

          // 渠道信息正常，继续原有逻辑
          this.$emit("change", item);
          this.currentCuotomer = item;
          return true;
        }
        return false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.offsite-detail {
  height: 100%;
  overflow-y: auto;
  background-color: #f7f8fa;
  padding: 12px;
  .qrcode {
    text-align: center;
    img {
      width: 200px;
      height: 200px;
    }
    padding: 20px 40px 30px;
  }
}

.contract-info {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  .btn {
    text-align: right;
    margin: 12px 0;
  }
}

.contract-header {
  padding: 16px;
  border-bottom: 1px solid #f5f5f5;

  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .label {
    color: #969799;
    font-size: 14px;
  }

  .value {
    color: #323233;
    font-size: 14px;
    margin-right: 8px;
  }

  .icon {
    color: #969799;
    font-size: 16px;
  }
}

.info-grid {
  padding: 12px 16px;

  .grid-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .grid-item {
      flex: 1;
      font-size: 12px;

      .label {
        color: #969799;
        margin-right: 4px;
      }

      .value {
        color: #323233;
      }
    }
  }
}
.info-grid2 {
  border-bottom: 1px solid #dddedf;
}

.undetailed-data {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;

  .icon {
    color: #969799;
    font-size: 16px;
    margin-right: 8px;
  }

  span {
    color: #323233;
    font-size: 14px;
  }
}

.card-details-table {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  padding: 0;

  ::v-deep .el-table {
    // 去除表格边框
    &::before,
    &::after {
      display: none;
    }

    // 修改表格内边框颜色
    td,
    th {
      border-color: #ebedf0;
    }

    // 去除表格hover效果
    tbody tr:hover > td {
      background-color: transparent !important;
    }

    // 调整单元格内边距
    td,
    th {
      padding: 12px 0;
    }

    // 调整字体大小和颜色
    td {
      font-size: 14px;
      color: #323233;
    }

    // 调整表头单元格内容位置
    th > .cell {
      padding: 0;
    }

    // 调整内容单元格内容位置
    td > .cell {
      padding: 0;
    }
  }

  .del {
    text-decoration: line-through;
  }
  .card-no-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    padding: 0 8px;

    .copy-icon {
      color: #969799;
      font-size: 16px;
      cursor: pointer;
      padding: 4px;

      &:hover {
        color: #1989fa;
      }

      &:active {
        opacity: 0.7;
      }
    }
  }

  .status-icon {
    font-size: 16px;

    &.activated {
      color: #07c160;
    }

    &.not-activated {
      color: #ee0a24;
    }
  }
}

.waiting-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: #969799;

  .icon {
    font-size: 48px;
    margin-bottom: 8px;
  }

  span {
    font-size: 14px;
  }
}
</style> 